export const hiddenCategories = [
  'solskjermingTidsvariabler',
  'interntVarmetilskud',
  'beregningCo2',
  'primaerenergifaktorer',
  'energipris',
  'energipolitiskVektetEnergibehov',
  'driftstider',
  'utetemperatur',
  'varmetilskuddSol',
  'fasteVerdier'
];

export const hiddenFields = [
  'areal_oppv',
  'faseforskjell_utetemp_varmetap',
  'aarsmiddeltemp_inne',
  'aarsmiddeltemp_ute',
  'luftmengde_spesifikk_tilluft',
  'luftmengde_spesifikk_avtrekksluft',
  'energibehov_tappevann',
  'energibehov_belysning',
  'energibehov_utstyr',
  'areal_avkjoelt_andel',
  'temp_settpunkt_kjoeling',
  'tid_drift_pumpe_oppvarming',
  'pumpeeffekt_spesifikk_kjoling',
  'tid_drift_pumpe_kjoling',
  'temp_differanse_veskekrets_kjoling',
  'systemvirkningsgrad_solcelle',
  'el_solcelle_andel_el_spesifikt_forbruk',
  'effektfaktor_kjoeleanlegg',
  'tid_drift_pumpe_oppv',
  'solfaktor_total_glass_skjerming_oest',
  'solfaktor_total_glass_skjerming_vest',
  'solfaktor_total_glass_skjerming_soer',
  'solfaktor_total_glass_skjerming_nord',
  'solfaktor_total_glass_skjerming_tak'
];
